import { locale, addLocale } from 'primereact/api';

addLocale('es', {
    startsWith: "Empieza con",
    contains: "Contiene",
    notContains: "No contiene",
    endsWith: "Termina con",
    equals: "Igual a",
    notEquals: "Distinto a",
    noFilter: "Sin filtro",
    lt: "Menor que",
    lte: "Menor o igual que",
    gt: "Mayor que",
    gte: "Mayor o igual que",
    dateIs: "Fecha es",
    dateIsNot: "Fecha no es",
    dateBefore: "Fecha es antes",
    dateAfter: "Fecha es después",
    clear: "Limpiar",
    apply: "Aplicar",
    matchAll: "Coincidir con todos",
    matchAny: "Coincidir con cualquiera",
    addRule: "Agregar regla",
    removeRule: "Eliminar regla",
    accept: "Aceptar",
    reject: "Rechazar",
    choose: "Elegir",
    upload: "Subir",
    cancel: "Cancelar",
    dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    today: "Hoy",
    weekHeader: "Sem",
    firstDayOfWeek: 1,
    dateFormat: "dd/mm/yy",
    weak: "Débil",
    medium: "Medio",
    strong: "Fuerte",
    passwordPrompt: "Ingresa una contraseña",
    emptyMessage: "No se encontraron resultados",
    emptyFilterMessage: "No se encontraron resultados"
});

locale('es');
